<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
    <p> {{data.question}} </p>
</div>
<div mat-dialog-actions>
    <button mat-raised-button color="primary" [mat-dialog-close]="true"> {{data.buttonOkName}} </button>
    <button mat-raised-button [mat-dialog-close]="false"> {{data.buttonCancelName}} </button>
</div>